$(document).on('turbolinks:load', function () {
  if ($('body').hasClass('webhooks')) {
    $('#webhook_platform_name').on('change', '', function (e) {
      check_ddi()
      check_eduzz()
    });
    function check_ddi() {
      if ($('#webhook_platform_name') && ($('#webhook_platform_name').val() == 'mailchimp' || $('#webhook_platform_name').val() == 'activecampaign')) {
        $('.ddi').show()
      } else {
        $('.ddi').hide()
      }
    }
    function check_eduzz() {
      if ($('#webhook_platform_name') && ($('#webhook_platform_name').val() == 'eduzz' ||
        $('#webhook_platform_name').val() == 'asaas')) {
        $('.hotmart_kiwify_eduzz').show()
        $('.hotmart_kiwify_eduzz').find('input').attr('name', 'webhook[platform_key]')
      } else {
        $('.hotmart_kiwify_eduzz').hide()
        $('.hotmart_kiwify_eduzz').find('input').attr('name', 'webhook[platform_key_2]')
      }
      if ($('#webhook_platform_name').val() == 'shopify') {
        $('.shopify').show()
        $('.shopify').find('input').first().attr('name', 'webhook[platform_key]')
      } else {
        $('.shopify').hide()
        $('.shopify').find('input').first().attr('name', 'webhook[platform_key_2]')
      }
    }
    check_ddi();
    check_eduzz();
  }
  window.copyToClipboard = function (text) {
    navigator.clipboard.writeText(text);
    toastr.success('Copiado', '', { closeButton: true, progressBar: true, timeOut: 1500 })
  }
})
